import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App.tsx';
import './index.css';
import { ErrorFallback } from './components/ErrorFallback';
import { ProvidersWrapper } from './providers/ProvidersWrapper.tsx';

const logError = (error: Error, info: { componentStack: string }) => {
  // In a real app, you'd send this to an error reporting service
  console.error('Error:', error);
  console.error('Component Stack:', info.componentStack);
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={logError}
      onReset={() => {
        // Reset the state of your app here
        window.location.reload();
      }}
    >
      <ProvidersWrapper>
        <App />
      </ProvidersWrapper>
    </ErrorBoundary>
  </StrictMode>,
);
